import React from 'react'
import {type ModeSettingEnum} from '@colonist/types'
import {getVPInformation, getVPTypeIconPath} from './UIGameVPInformation.ts'
import styles from './UIGameHelpVPInformation.module.scss'
import {T, Tooltip} from '@colonist/ui'
import {type PlayerColor, VictoryPointType} from '@colonist/game-states'
import clsx from 'clsx'
import IconTrophy from '@static/images/icon_trophy.svg'

export interface UIGameHelpVPInformationProps {
    gameMode: ModeSettingEnum
    isMechanicIslandExplorationActive: boolean
    playerColor: PlayerColor
    victoryPointsToWin: number
}

export const UIGameHelpVPInformation = ({
    gameMode,
    isMechanicIslandExplorationActive,
    playerColor,
    victoryPointsToWin,
}: UIGameHelpVPInformationProps) => {
    const gameModeData = getVPInformation(gameMode, isMechanicIslandExplorationActive)

    return (
        <div className={styles.uiGameInfoContainer}>
            <div className={styles.description}>
                <span><T id={{key: 'strings:game.beginnerTips.reach'}}/> </span>
                <span className={styles.point}>{victoryPointsToWin} </span>
                <img
                    className={styles.trophyIcon}
                    src={IconTrophy}
                />
                <span> <T id={{key: 'strings:game.beginnerTips.toWinTheGame'}}/></span>
            </div>
            {gameModeData.map((item, index: number) => (
                <div className={styles.itemRow} key={index}>
                    <Tooltip
                        centerText
                        className={styles.itemTitle} content={item.description && <T id={item.description}/>}
                        delay={0}>
                        <img
                            className={styles.icon}
                            src={getVPTypeIconPath(item, playerColor)}
                        />
                        {item.secondaryIcon != null && <img
                            className={clsx(styles.secondaryIcon, {
                                [styles.metropolis]: item.type === VictoryPointType.Metropolis,
                                [styles.chits]: item.type === VictoryPointType.Chits,
                            })}
                            src={item.secondaryIcon}
                        />}
                        <div className={styles.title}><T id={item.title}/></div>
                    </Tooltip>
                    <div className={styles.pointContainer}>
                        <div className={styles.point}>+{item.vpAmount}</div>
                        <img
                            className={styles.trophyIcon}
                            src={IconTrophy}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}
